import * as React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';

export interface HtmlHeadingProps {
    html: HtmlString;
    type: keyof Pick<React.ReactHTML, 'h1' | 'h2' | 'h3' | 'h4'>;
    id?: string;
    className?: string;
}

export const HtmlHeading: React.FC<HtmlHeadingProps> = props => {
    const { type, html, id, className } = props;

    return React.createElement(type, { className, id, dangerouslySetInnerHTML: { __html: html.value } });
};
